import { lazy } from "react";

// This is an index file to make it easier to import the component
const ExportDocumentationFee = lazy(() => import("./index.jsx"));

export default ExportDocumentationFee;
